import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../style/Modal.css";
import ModalChoice from "./ModalChoice";
import ModalAfterChoice from "./modalAfterChoice";
import { SCHEMALINK_URL } from "./schemalink";
import Papa from "papaparse";

function ModalArticles({
    data,
    input,
    dataUpdate,
    relMethod,
    file,
    manualFile,
    isModalOpen,
    graphName,
    visMethod,
    embMethod,
}) {
    const [fieldNames, setFieldNames] = useState([]);
    const [keyword, setKeyword] = useState("");
    const [selectedPubMedId, setSelectedPubMedId] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    const [tripleData, setTripleData] = useState([]);
    const [tripleErr, setTripleErr] = useState(false);
    const [errorMessage, setErrorMessage] = useState(
        "Error: didn't find triple to extract, please double check parameters and try again"
    );
    const [tripleLoading, setTripleLoading] = useState(true);
    const [tableData1, setTableData1] = useState();
    const [tableData2, setTableData2] = useState({ columns: [], data: [] });
    const [abstract, setAbstract] = useState();

    const navigate = useNavigate();

    // console.log('table data 2 state:\n', tableData2)
    // console.log('table data 1 state:\n', tableData1)

    const rel = [
        "mirna-go",
        "mirna-disease",
        "mirna-chemical",
        "lncrna-disease",
        "lncrna-mrna",
        "lncrna-gene",
        "snp-snorna",
        "lncrna-go",
        "snorna-go",
        "mrna-chemical",
        "mrnavaccine-disease",
        "snorna-disease",
        "snorna-gene",
        "snorna-lncrna",
        "mirna-gene",
        "mirna-mirna",
        "snorna-mirna",
    ];
    let pmid = null;

    const send_csv_triples = async (CSV) => {
        try {
            const reqOptions = {
                method: "POST",
                headers: { "Content-type": "application/json" },
                body: JSON.stringify(CSV),
            };

            const query =
                "https://bio-viber.biodata.di.unimi.it/api/receive_csv";
            const response = await fetch(query, reqOptions);
            if (!response.ok) {
                throw new Error(`HTTP Error: ${response.status}`);
            }
            const data = await response.json();
            console.log(data.message);
            return data;
        } catch (error) {
            console.log(error.message);
            return "Error";
        }
    };

    const getTriples = async () => {
        try {
            const query = `https://bio-viber.biodata.di.unimi.it/api/get_triples_data?pmid=${selectedPubMedId || pmid}&relMethod=${relMethod}&graphDB=${graphName}`;
            const response = await fetch(query);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const triples_data = await response.json();
            console.log(triples_data);
            return triples_data;
        } catch (error) {
            console.log(error.message);
            return "Error";
        }
    };

    const getOntology = async () => {
        try {
            const query = `https://bio-viber.biodata.di.unimi.it/api/get_ontology?visMethod=${visMethod}`;
            const response = await fetch(query);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const ontology_data = await response.json();
            console.log(ontology_data);
            return ontology_data;
        } catch (error) {
            console.log(error.message);
            return "Error";
        }
    };

    const getOntology_stream = async () => {
        try {
            const query = `https://bio-viber.biodata.di.unimi.it/api/get_ontology?visMethod=${visMethod}`;
            const response = await fetch(query);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = "";

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, { stream: true });

                let parts = buffer.split("\n");
                buffer = parts.pop();

                for (const part of parts) {
                    if (part.trim()) {
                        try {
                            const obj = JSON.parse(part);

                            // Change the order of table2: sub, pred, obj, sub_type, obj_type, putative, ID
                            let table2_col = [];
                            table2_col.push(obj["columns"][5]);
                            table2_col.push(obj["columns"][0]);
                            table2_col.push(obj["columns"][6]);
                            table2_col.push(obj["columns"][1]);
                            table2_col.push(obj["columns"][2]);
                            table2_col.push(obj["columns"][3]);
                            table2_col.push(obj["columns"][4]);
                            let table2_row = [];
                            for (let i = 0; i < obj["data"].length; i++) {
                                let row = [];
                                row.push(obj["data"][i][5]);
                                row.push(obj["data"][i][0]);
                                row.push(obj["data"][i][6]);
                                row.push(obj["data"][i][1]);
                                row.push(obj["data"][i][2]);
                                row.push(obj["data"][i][3]);
                                row.push(obj["data"][i][4]);

                                table2_row.push(row);
                            }
                            const tableDataOrder = {
                                columns: table2_col,
                                data: table2_row,
                            };
                            // setTableData2(tableDataOrder);
                            console.log("table data 2:\n", tableDataOrder);
                            setTableData2((prev) => ({
                                columns: prev.columns.length
                                    ? prev.columns
                                    : tableDataOrder.columns, // keep existing cols
                                data: [...prev.data, ...tableDataOrder.data], // append rows
                            }));
                        } catch (err) {
                            setTripleData("Error");
                            console.error("JSON parse error:", part, err);
                        }
                    }
                }
            }
        } catch (error) {
            setTripleData("Error");
            console.log(error.message);
            return "Error";
        }
    };

    // Building the graph can outlast the gateway's per-request timeout on big
    // KGs (e.g. PKT-KG), so it runs as a background job on the backend: start
    // it, then poll its status until the graph (or an error) comes back.
    const getGraph = async () => {
        try {
            const query = `https://bio-viber.biodata.di.unimi.it/api/get_graph/start?pmid=${selectedPubMedId || pmid}&visMethod=${visMethod}&embMethod=${embMethod}`;
            const startResponse = await fetch(query);

            if (!startResponse.ok) {
                throw new Error(`HTTP error! status: ${startResponse.status}`);
            }

            const { job_id } = await startResponse.json();
            const statusQuery = `https://bio-viber.biodata.di.unimi.it/api/get_graph/status?job_id=${job_id}`;
            const pollInterval = 3000;
            const maxWait = 30 * 60 * 1000;

            // A single status check can fail on its own over a long wait (dropped
            // connection, a gateway error page) while the job is fine -- only give
            // up after several failures in a row.
            const maxConsecutiveFailures = 5;
            let consecutiveFailures = 0;

            for (let waited = 0; waited < maxWait; waited += pollInterval) {
                await new Promise((resolve) => setTimeout(resolve, pollInterval));
                let response;
                try {
                    response = await fetch(statusQuery);
                } catch (error) {
                    if (++consecutiveFailures >= maxConsecutiveFailures) throw error;
                    continue;
                }

                // 202 = still building
                if (response.status === 202) {
                    consecutiveFailures = 0;
                    continue;
                }
                // 502/503/504 come from the gateway, not the job
                if ([502, 503, 504].includes(response.status) && ++consecutiveFailures < maxConsecutiveFailures) {
                    continue;
                }
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                return data;
            }
            throw new Error("Graph building timed out");
        } catch (error) {
            console.log(error.message);
            const data = "Error";
            return data;
        }
    };

    const handleConfirm = async () => {
        // Handle backdrop removal manually
        const backdrops = document.querySelectorAll(".modal-backdrop");
        for (let i = 0; i < 2; i++) {
            backdrops[i].remove();
        }

        // CSV request if relation set on csv
        if (relMethod === "csv" && file) {
            const csv_file = await handleJson(relMethod);
            const csv_message = await send_csv_triples(csv_file);
            if (csv_message === "Error") {
                setTripleData("Error");
            }
        }

        // CSV request for manual form
        if (relMethod === "manual" && manualFile) {
            const manual_file = await handleJson(relMethod);
            const csv_message = await send_csv_triples(manual_file);
            if (csv_message === "Error") {
                setTripleData("Error");
            }
        }

        // 1st request
        //* Raw Table
        const triples_data = await getTriples();
        if (triples_data === "Error") {
            setTripleData("Error");
            return;
        }
        console.log(triples_data["table1"]);
        setTableData1(triples_data["table1"]);
        setAbstract(triples_data["abstract"]);

        //* Ontology Table
        // const ontology_data = await getOntology();
        // if (ontology_data === "Error") {
        //   setTripleData("Error");
        //   return;
        // }

        // console.log(ontology_data['table2']);
        // setTableData2(ontology_data['table2']);

        // // Change the order of table2: sub, pred, obj, sub_type, obj_type, putative, ID
        // let table2_col = [];
        // table2_col.push(ontology_data['table2']['columns'][5]);
        // table2_col.push(ontology_data['table2']['columns'][0]);
        // table2_col.push(ontology_data['table2']['columns'][6]);
        // table2_col.push(ontology_data['table2']['columns'][1]);
        // table2_col.push(ontology_data['table2']['columns'][2]);
        // table2_col.push(ontology_data['table2']['columns'][3]);
        // table2_col.push(ontology_data['table2']['columns'][4]);
        // let table2_row = [];
        // for (let i = 0;i < ontology_data['table2']['data'].length;i++) {
        //   let row = []
        //   row.push(ontology_data['table2']['data'][i][5]);
        //   row.push(ontology_data['table2']['data'][i][0]);
        //   row.push(ontology_data['table2']['data'][i][6]);
        //   row.push(ontology_data['table2']['data'][i][1]);
        //   row.push(ontology_data['table2']['data'][i][2]);
        //   row.push(ontology_data['table2']['data'][i][3]);
        //   row.push(ontology_data['table2']['data'][i][4]);

        //   table2_row.push(row);
        // }
        // const tableDataOrder = {columns: table2_col, data: table2_row};
        // setTableData2(tableDataOrder);

        await getOntology_stream();

        // 2nd request
        const graph_data = await getGraph();
        console.log("Graph data:\n", graph_data);
        if (graph_data === "Error") {
            setErrorMessage("Building the graph has failed.");
        }
        setTripleData(graph_data);
        updateData(graph_data);
    };

    const handleJson = async (rel) => {
        try {
            console.log(rel);
            let file_parse;
            if (rel === "csv") {
                file_parse = await csv_parse();
            } else {
                file_parse = manualFile;
            }
            console.log(file_parse);
            pmid = file_parse[0]["PubMedID"];

            let file_json = {};
            const keys = Object.keys(file_parse[0]);

            for (let i = 0; i < keys.length; i++) {
                let inner_obj = {};
                for (let j = 0; j < file_parse.length; j++) {
                    inner_obj[j] = file_parse[j][keys[i]];
                }
                file_json[keys[i]] = inner_obj;
            }
            console.log(file_json);
            return file_json;
        } catch (error) {
            console.log(error.message);
        }
    };

    const csv_parse = () => {
        return new Promise((resolve, reject) => {
            // Covert csv to JSON
            Papa.parse(file, {
                header: true,
                skipEmptyLines: true,
                complete: function (result) {
                    resolve(result.data); // List of Objects
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    };

    //? why is this useEffect necessary?
    useEffect(() => {
        if (isModalOpen) {
            handleConfirm();
        }
    }, [isModalOpen]);

    // Manages receiving triples
    useEffect(() => {
        if (tripleData === "Error") {
            setTripleErr(true);
            setTripleLoading(false);
            console.log(tripleErr);
        } else if (Object.keys(tripleData).length === 0) {
            setTripleLoading(true);
        } else if (Object.keys(tripleData).length > 0) {
            setTripleLoading(false);
        }
    }, [tripleData]);

    // Manages receiving abstracts
    useEffect(() => {
        if (data && data.length > 0 && typeof data !== "string") {
            setFieldNames(Object.keys(data[0]));
            console.log(Object.keys(data[0]));
            setIsLoading(false);
            setError(false);
        }
        if (typeof data === "string") {
            setError(true);
        }
    }, [data]);

    useEffect(() => {
        setKeyword(input);
    }, [input]);

    useEffect(() => {
        if (input !== keyword) {
            setIsLoading(true);
            setKeyword(input);
        }
    }, [input, keyword]);

    const updateData = (newData) => {
        if (newData === "Error") {
            console.log("ERROR");
        }
        dataUpdate(newData);
        // Esempio di aggiornamento dello stato con i nuovi dati
        // setDati(newData);
    };

    const handleCheckboxChange = (pubMedId) => {
        setSelectedPubMedId(pubMedId);
    };

    const handleCloseChoice = () => {
        window.location.reload();
    };

    const handleClose = () => {
        if (!tripleErr) {
            navigate("/displayGraph", {
                state: {
                    tripleData: tripleData,
                    abstract: abstract,
                    tableData2: tableData2,
                    visMethod: visMethod,
                },
            });
        } else {
            // Back to Schema Link -- Bio-Viber's own homepage isn't for users
            window.location.href = SCHEMALINK_URL;
        }
    };

    return (
        <div>
            <ModalAfterChoice data={tripleData} />
            <div
                className="modal fade"
                id="modalGetTriple"
                data-bs-backdrop="static"
                tabIndex="-1"
            >
                <div className="modal-dialog modal-dialog-scrollable modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                {/* {tableData1 === undefined ? 'Extracting Triples...' : 'Setting up Graph...'} */}
                                {tripleErr ? (
                                    <p className="text-danger">
                                        {errorMessage}
                                    </p>
                                ) : tripleLoading &&
                                  tableData1 === undefined ? (
                                    <>
                                        <p>Extracting Triples...</p>
                                        <div
                                            className="spinner-grow"
                                            role="status"
                                        ></div>
                                    </>
                                ) : tripleLoading &&
                                  tableData1 !== undefined ? (
                                    <>
                                        <p>
                                            Setting up Graph... (PMID:{" "}
                                            {tableData1["data"][0][6]})
                                        </p>
                                        <div
                                            className="spinner-grow"
                                            role="status"
                                        ></div>
                                    </>
                                ) : (
                                    <p
                                        className="text-success"
                                        style={{
                                            fontSize: "1.3rem",
                                            textAlign: "center",
                                        }}
                                    >
                                        <strong>
                                            Data received successfully (PMID:{" "}
                                            {tableData1["data"][0][6]})
                                        </strong>
                                    </p>
                                )}
                            </h5>
                        </div>
                        <div className="modal-body">
                            {/* {tripleErr ? <p className="text-danger">Error: didn't find triple to extract, please double check parameters and try again</p>
                      : (tripleLoading ? 
                        <div className="text-center">
                            <div className="spinner-border" role="status"></div>
                            <hr/>
                        </div>
                        :<><p className="text-success" style={{fontSize: '1.5rem', textAlign: 'center'}}><strong>Data received successfully</strong></p><hr/></>  
                        )
              } */}

                            {tableData1 !== undefined && !tripleErr ? (
                                <>
                                    <h5
                                        style={{ color: "#0d6efd" }}
                                    >{`Raw Triples`}</h5>
                                    <table className="table table-striped table-bordered center-text align-middle">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                {tableData1["columns"]
                                                    .slice(0, 6)
                                                    .map((col, index) => (
                                                        <th
                                                            key={index}
                                                            scope="col"
                                                        >
                                                            {col
                                                                .split("_")
                                                                .join(" ")}
                                                        </th>
                                                    ))}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {tableData1["data"].map(
                                                (row, index) => (
                                                    <tr>
                                                        <th scope="row">
                                                            {index + 1}
                                                        </th>
                                                        {row.map(
                                                            (
                                                                row_data,
                                                                index,
                                                            ) => {
                                                                if (
                                                                    index === 1
                                                                ) {
                                                                    return (
                                                                        <td
                                                                            key={
                                                                                index
                                                                            }
                                                                        >
                                                                            {row_data
                                                                                .split(
                                                                                    "_",
                                                                                )
                                                                                .join(
                                                                                    " ",
                                                                                )}
                                                                        </td>
                                                                    );
                                                                } else if (
                                                                    index !== 6
                                                                ) {
                                                                    return (
                                                                        <td
                                                                            key={
                                                                                index
                                                                            }
                                                                        >
                                                                            {
                                                                                row_data
                                                                            }
                                                                        </td>
                                                                    );
                                                                }
                                                            },
                                                        )}
                                                    </tr>
                                                ),
                                            )}
                                        </tbody>
                                    </table>
                                </>
                            ) : (
                                <></>
                            )}

                            {tableData2.columns.length !== 0 ? (
                                <>
                                    <h5
                                        style={{ color: "#0d6efd" }}
                                    >{`Ontology-grounded Triples`}</h5>
                                    <div className="table-responsive">
                                        <table className="table table-striped table-bordered center-text align-middle ">
                                            <thead>
                                                <tr>
                                                    <th scope="col">#</th>
                                                    {tableData2["columns"]
                                                        .slice(0, 6)
                                                        .map((col, index) => (
                                                            <th
                                                                key={index}
                                                                scope="col"
                                                            >
                                                                {col
                                                                    .split("_")
                                                                    .join(" ")}
                                                            </th>
                                                        ))}
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {tableData2["data"].map(
                                                    (row, index) => (
                                                        <tr>
                                                            <th scope="row">
                                                                {index + 1}
                                                            </th>
                                                            {row.map(
                                                                (
                                                                    row_data,
                                                                    index,
                                                                ) => {
                                                                    if (
                                                                        index ===
                                                                            0 ||
                                                                        (index ===
                                                                            2 &&
                                                                            index !==
                                                                                5)
                                                                    ) {
                                                                        return (
                                                                            <td
                                                                                key={
                                                                                    index
                                                                                }
                                                                            >
                                                                                {" "}
                                                                                <a
                                                                                    href={
                                                                                        row_data
                                                                                    }
                                                                                >
                                                                                    {row_data
                                                                                        .split(
                                                                                            "/",
                                                                                        )
                                                                                        .pop()}
                                                                                </a>{" "}
                                                                            </td>
                                                                        );
                                                                    } else if (
                                                                        index ===
                                                                        1
                                                                    ) {
                                                                        return (
                                                                            <td
                                                                                key={
                                                                                    index
                                                                                }
                                                                            >
                                                                                {row_data
                                                                                    .split(
                                                                                        "_",
                                                                                    )
                                                                                    .join(
                                                                                        " ",
                                                                                    )}
                                                                            </td>
                                                                        );
                                                                    } else if (
                                                                        index !==
                                                                        6
                                                                    ) {
                                                                        return (
                                                                            <td
                                                                                key={
                                                                                    index
                                                                                }
                                                                            >
                                                                                {
                                                                                    row_data
                                                                                }
                                                                            </td>
                                                                        );
                                                                    }
                                                                },
                                                            )}
                                                        </tr>
                                                    ),
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            ) : (
                                <></>
                            )}
                        </div>
                        {tripleLoading ? (
                            <></>
                        ) : (
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                    onClick={handleClose}
                                >
                                    Close
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* {<ModalChoice pubMedId={selectedPubMedId} onDataUpdate={updateData}/>} */}

            <div className="modal fade modal-xl" id="modalArticles">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1
                                className="modal-title fs-5"
                                id="staticBackdropLabel"
                            >
                                Articles with keyword: {keyword}
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => window.location.reload()}
                            ></button>
                        </div>
                        <div className="modal-body">
                            {error ? (
                                <div className="text-center">
                                    <p className="text-danger">
                                        Error: Unable to send request, please
                                        double check parameters and try again
                                    </p>
                                    <button
                                        type="button"
                                        className="btn btn-danger"
                                        data-bs-dismiss="modal"
                                        onClick={handleCloseChoice}
                                    >
                                        Close
                                    </button>
                                </div>
                            ) : isLoading ? ( //show spinner if data is loading
                                <div className="text-center">
                                    <div
                                        className="spinner-grow"
                                        role="status"
                                    ></div>
                                </div>
                            ) : (
                                //show table
                                <div className="table-responsive">
                                    <table className="table table-striped table-bordered center-text align-middle">
                                        <thead>
                                            <tr>
                                                {fieldNames.map(
                                                    (fieldName, index) =>
                                                        index !== 5 &&
                                                        index !== 3 && (
                                                            <th
                                                                key={fieldName}
                                                                className={
                                                                    index === 1
                                                                        ? "center-text wide-column"
                                                                        : "center-text narrow-column"
                                                                }
                                                            >
                                                                {index === 0
                                                                    ? "PubMedId"
                                                                    : fieldName}
                                                            </th>
                                                        ),
                                                )}
                                                <th scope="col">selected</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.map((item, index) => (
                                                <tr
                                                    key={index}
                                                    className="separated-row"
                                                >
                                                    <th
                                                        scope="row"
                                                        className="center-text narrow-column"
                                                    >
                                                        <a
                                                            className="no-underline"
                                                            target="_blank"
                                                            href={`https://pubmed.ncbi.nlm.nih.gov/${item[fieldNames[0]]}`}
                                                        >
                                                            {
                                                                item[
                                                                    fieldNames[0]
                                                                ]
                                                            }
                                                        </a>
                                                    </th>
                                                    <td className="truncate-text wide-column">
                                                        {typeof item[
                                                            fieldNames[1]
                                                        ] === "string" ? (
                                                            <>
                                                                {item[
                                                                    fieldNames[1]
                                                                ]
                                                                    .split(" ")
                                                                    .slice(
                                                                        0,
                                                                        50,
                                                                    )
                                                                    .join(" ")}
                                                                {item[
                                                                    fieldNames[1]
                                                                ].split(" ")
                                                                    .length >
                                                                    50 && (
                                                                    <span className="more-text">
                                                                        {item[
                                                                            fieldNames[1]
                                                                        ]
                                                                            .split(
                                                                                " ",
                                                                            )
                                                                            .slice(
                                                                                50,
                                                                            )
                                                                            .join(
                                                                                " ",
                                                                            )}
                                                                    </span>
                                                                )}
                                                            </>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </td>
                                                    <td className="center-text narrow-column">
                                                        {Array.isArray(
                                                            item[fieldNames[2]],
                                                        )
                                                            ? item[
                                                                  fieldNames[2]
                                                              ].length === 1
                                                                ? `${item[fieldNames[2]][0].firstname} ${item[fieldNames[2]][0].initials} ${item[fieldNames[2]][0].lastname}`
                                                                : `${item[fieldNames[2]][0].firstname} ${item[fieldNames[2]][0].initials} ${item[fieldNames[2]][0].lastname} etc.`
                                                            : ""}
                                                    </td>
                                                    <td className="center-text narrow-column">
                                                        {item[fieldNames[4]]}
                                                    </td>
                                                    <td className="center-text narrow-column">
                                                        {item[fieldNames[6]]}
                                                    </td>
                                                    <td className="center-text narrow-column">
                                                        <input
                                                            type="checkbox"
                                                            className="large-checkbox"
                                                            checked={
                                                                selectedPubMedId ===
                                                                item[
                                                                    fieldNames[0]
                                                                ]
                                                            }
                                                            onChange={() =>
                                                                handleCheckboxChange(
                                                                    item[
                                                                        fieldNames[0]
                                                                    ],
                                                                )
                                                            }
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {!error && (
                                        <div className="modal-foot text-center">
                                            <div class="d-grid gap-2 col-6 mx-auto">
                                                <button
                                                    type="button"
                                                    className="btn btn-success"
                                                    disabled={!selectedPubMedId}
                                                    data-bs-dismiss="modal"
                                                    onClick={handleConfirm}
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#modalGetTriple"
                                                >
                                                    Confirm
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        {/*!error &&(<div className="modal-foot text-center">
              <button type="button" className="btn btn-success" data-bs-toggle="modal" data-bs-target="#modalChoice"  disabled={!selectedPubMedId}>Confirm</button>
            </div>)*/}
                        <br></br>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalArticles;
